

const komisyonDurumuOptions = [
    {
        value: 0,
        text: "Komisyon Yok"
    },
    {
        value: 1,
        text: "Komisyon Var (% olarak)"
    },
    {
        value: 2,
        text: "Komisyon Var (TL Olarak)"
    },
]


export default komisyonDurumuOptions